/**
 * Microsoft Clarity — solo carga si existe REACT_APP_CLARITY_PROJECT_ID en .env
 * @see https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-setup
 */
export function initClarity() {
  const projectId =
    typeof process.env.REACT_APP_CLARITY_PROJECT_ID === "string"
      ? process.env.REACT_APP_CLARITY_PROJECT_ID.trim()
      : "";

  if (!projectId) return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", projectId);
}
